module.exports = __webpack_public_path__ + "static/media/chat_bubble_blue.4a1e6833.svg";